<template>
  <div>
    <warning-banner-item
        :warning="warning"
        @cta-clicked="hasMultipleWarnings ? openOverviewModal() : $emit('cta-clicked', warning)"
    />

    <client-only>
      <portal to="MODAL">
        <warnings-overview-modal
            v-if="isOverviewModalOpen"
            :warnings="warnings"
            @close="isOverviewModalOpen = false"
            @cta-clicked="(w) => $emit('cta-clicked', w)"
        />
      </portal>
    </client-only>
  </div>
</template>

<script>
import WarningBannerItem from './WarningBannerItem';
import WarningsOverviewModal from './WarningsOverviewModal';

export default {
  name: 'warning-banner',
  components: {
    WarningBannerItem,
    WarningsOverviewModal,
  },
  props: {
    warnings: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      isOverviewModalOpen: false,
    };
  },
  computed: {
    hasMultipleWarnings () {
      return this.warnings.length > 1;
    },
    warning () {
      const multipleWarningsObj = {
        short_text: 'To continue receiving leads, a few items need your attention.',
        full_text: 'To continue receiving leads, a few items need your attention.',
        short_cta: 'View',
        full_cta: 'View',
      };

      // If there is only one warning return that, otherwise return a
      // hardcoded message for multiple warnings.
      return this.hasMultipleWarnings
        ? multipleWarningsObj
        : this.warnings[0];
    },
  },
  methods: {
    openOverviewModal () {
      this.isOverviewModalOpen = true;
    },
  },
};
</script>
